module.exports = __webpack_public_path__ + "img/shipped-cross-sell-background-mobile.de3b72e.png";